export default __webpack_public_path__ + "static/media/IMG_1352.2af39f50.jpg";